// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__9yBvf","inner":"Form_inner__3B9dS","range":"Form_range__3T-gz","name":"Form_name__1VyqU","actions":"Form_actions__3HGQA"};